export const DecimalHelper = {
  fixed(num?: string | number, digits?: number) {
    if (num === undefined || num === null) return "";
    if (typeof num === "number") return num.toFixed(digits);
    return parseFloat(num).toFixed(digits);
  },
  locale(num?: string | number) {
    if (num === undefined || num === null) return "";
    if (typeof num === "number") return num.toLocaleString();
    return parseFloat(num).toLocaleString();
  },
};
